import { LucideIcon } from '@kerfjs/ui/lucide-icon';
import { Toolbar } from '@kerfjs/ui/toolbar';
import { ToolbarControlGroup } from '@kerfjs/ui/toolbar-control-group';
import { ToolbarText } from '@kerfjs/ui/toolbar-text';
import type { SafeHtml } from 'kerfjs';
import { Paperclip } from 'lucide';

import { libraryProjects, libraryScope } from '../../../data/state.js';
import { PrimaryAddControl } from '../../demand-editor/components/primary-add-control.js';

export function LibraryHeader(): SafeHtml {
  const scope = libraryScope.value;
  const title = scope === '' ? 'Organization' : (libraryProjects.value.find((p) => p.id === scope)?.name ?? 'Project');
  return (
    <Toolbar
      label="Knowledge Base Scope"
      leading={<ToolbarText text={title} size="xlarge" headingLevel={2} />}
      trailing={
        <>
          <ToolbarControlGroup label="Attach Document" appearance="borderless">
            <button type="button" data-action="lib-upload-open" aria-label="Attach Document">
              <LucideIcon icon={Paperclip} name="" />
            </button>
            <input
              class="app-visually-hidden"
              type="file"
              data-lib-upload
              multiple
              hidden
              aria-hidden="true"
              tabindex={-1}
            />
          </ToolbarControlGroup>
          <PrimaryAddControl action="lib-new-fact" label="New Fact…" />
        </>
      }
    />
  );
}
